export const USER_GROUP = {
    SYSTEM_ADMIN: 'R1',
    INVENTORY_CONTROLLER: 'R2',
    INVENTORY_PERSONNEL: 'R3',
    LOCAL_ADMIN: 'R4',
    CLIENT: 'R5',
    FINANCE: 'R6',
    AUDITOR: 'R7'
};
